let isShowing = false;

export function showSessionExpiredOverlay() {
  // Cegah tampil berkali-kali jika banyak request 401 bersamaan
  if (isShowing) return;
  if (window.location.pathname.includes('/login')) return;
  isShowing = true;

  // Bersihkan localStorage segera agar tidak terjadi race condition / bounce loop
  localStorage.clear();
  sessionStorage.clear();

  // Buat overlay element
  const overlay = document.createElement('div');
  overlay.id = 'session-expired-overlay';
  overlay.innerHTML = `
    <div style="
      position: fixed; inset: 0; z-index: 99999;
      background: rgba(0,0,0,0.6);
      backdrop-filter: blur(4px);
      display: flex; align-items: center; justify-content: center;
      font-family: 'Inter', 'Roboto', sans-serif;
    ">
      <div style="
        background: white; border-radius: 16px;
        padding: 40px; max-width: 400px; width: 90%;
        text-align: center; box-shadow: 0 20px 60px rgba(0,0,0,0.3);
        animation: slideUp 0.3s ease-out;
      ">
        <div style="
          width: 64px; height: 64px; margin: 0 auto 20px;
          background: #FFF3E0; border-radius: 50%;
          display: flex; align-items: center; justify-content: center;
          font-size: 28px;
        ">🔒</div>
        <h2 style="margin: 0 0 8px; font-size: 20px; color: #1a1a2e; font-weight: 700;">
          Sesi Anda Telah Berakhir
        </h2>
        <p style="margin: 0 0 24px; font-size: 14px; color: #666; line-height: 1.5;">
          Demi keamanan akun Anda, sesi login telah berakhir secara otomatis. 
          Silakan login kembali untuk melanjutkan.
        </p>
        <button id="btn-relogin" style="
          background: linear-gradient(135deg, #673AB7, #9C27B0);
          color: white; border: none; border-radius: 12px;
          padding: 14px 32px; font-size: 15px; font-weight: 600;
          cursor: pointer; width: 100%;
          transition: transform 0.15s, box-shadow 0.15s;
        " onmouseover="this.style.transform='scale(1.02)'; this.style.boxShadow='0 4px 15px rgba(103,58,183,0.4)'"
           onmouseout="this.style.transform='scale(1)'; this.style.boxShadow='none'"
        >
          Login Kembali
        </button>
        <p style="margin: 16px 0 0; font-size: 12px; color: #999;">
          Ini bukan error — ini fitur keamanan otomatis.
        </p>
      </div>
    </div>
    <style>
      @keyframes slideUp {
        from { opacity: 0; transform: translateY(20px); }
        to { opacity: 1; transform: translateY(0); }
      }
    </style>
  `;

  document.body.appendChild(overlay);

  const reloginBtn = document.getElementById('btn-relogin');
  if (reloginBtn) {
    reloginBtn.addEventListener('click', () => {
      isShowing = false;
      const el = document.getElementById('session-expired-overlay');
      if (el) el.remove();
      window.location.replace('/login');
    });
  }
}
